export default __webpack_public_path__ + "static/media/banner.a8afc24f.svg";